/**
 * We map the data attributes to the data-loc="phosphor-blog/scripts/lib/dev/dataProps.tsx:2:38" prop so that option clicking will defer to the data attributes from there.
 * See {@link React$DOMDataAttributes} in `vite-react-className-plugin.d.ts` for more details.
 */
export function dataProps(props: Record<string, unknown>): { $: true } {
  return { ...Object.fromEntries(Object.entries(props).filter(([key]) => key.startsWith("data-"))) } as { $: true };
}
